import React, { memo, useCallback, useState } from "react";
import { Theme, CircularProgress, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { Document, Page, pdfjs } from "react-pdf";
import { PDFDocumentProxy } from "pdfjs-dist";
import makeStyles from "@mui/styles/makeStyles";
import { Button, Dialog } from "@shared/components";
import { useAppSelector, useAppDispatch } from "@app/hooks";
import { closeDocumentDialog } from "@pdfViewer/store/ducks";
import { pdfViewerSelector } from "@pdfViewer/store/selectors";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`; //`//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    minWidth: "80vw",
    [theme.breakpoints.down("sm")]: {
      minWidth: "90vw",
      minHeight: "80vh",
    },
    [theme.breakpoints.between("sm", "md")]: {
      minWidth: "80vw",
      minHeight: "90vh",
    },
    [theme.breakpoints.between("md", "lg")]: {
      minWidth: "75vw",
      minHeight: "80vh",
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: "80vw",
    },
  },
  player: {
    // minHeight: "80vh",
    // [theme.breakpoints.down("sm")]: {
    //   minHeight: "50vh",
    // },
    // [theme.breakpoints.between("sm", "md")]: {
    //   minHeight: "60vh",
    // },
    // [theme.breakpoints.between("md", "lg")]: {
    //   minHeight: "68vh",
    // },
    // [theme.breakpoints.up("lg")]: {
    //   minHeight: "80vh",
    // },
    paddingBottom: theme.spacing(5),
    marginBottom: theme.spacing(5),
    filter: "drop-shadow(1px 1px 2px rgba(0, 0, 0,0.3))",
  },
  info: {
    overflowY: "scroll",
    width: 670,
    height: 190,
    fontSize: 13,

    "&>p": {
      marginBottom: "1rem",
    },
  },
}));

const PdfDialog = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const [numPages, setNumPages] = useState<number>(1);

  const { documentName, documentUrl, isOpenDocumentDialog } = useAppSelector(pdfViewerSelector);

  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isMedium = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLarge = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isXtraLarge = useMediaQuery(theme.breakpoints.up("lg"));

  const getPdfWidth = () => {
    if (isSmall) return 300;
    if (isMedium) return 500;
    if (isLarge) return 600;
    if (isXtraLarge) return 900;

    return 600;
  };
  const handleDialogClose = useCallback(() => {
    dispatch(closeDocumentDialog());
  }, [dispatch]);

  const onLoadSuccess = (pdf: PDFDocumentProxy) => {
    setNumPages(pdf.numPages);
  };

  const totalPages = Array.from({ length: numPages }, (_, i) => i);

  return (
    <Dialog
      classes={{
        paperScrollPaper: classes.paper,
      }}
      pdf={true}
      maxWidth="lg"
      title={documentName ?? ""}
      onClose={handleDialogClose}
      open={isOpenDocumentDialog}
      actions={
        <Button shape="sharp" size="medium" onClick={handleDialogClose}>
          Close
        </Button>
      }
    >
      <Document
        className={classes.player}
        file={documentUrl}
        loading={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "400px",
              fontSize: "1.2rem",
              fontWeight: "500",
              color: "#555",
            }}
          >
            <CircularProgress data-tesid={`pdf-loading-spinner`} />
          </div>
        }
        onLoadSuccess={onLoadSuccess}
        noData={null}
        error={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "400px",
              fontSize: "1.2rem",
              fontWeight: "500",
              color: "#d32f2f",
            }}
          >
            Faild to load PDF. Please try again later.
          </div>
        }
      >
        {totalPages.length > 0 &&
          totalPages.map((index) => {
            return <Page key={`page_${index + 1}`} pageNumber={index + 1} width={getPdfWidth()} />;
          })}
      </Document>
    </Dialog>
  );
};

export default memo(PdfDialog);
